export enum BannerType {
  INFO = 'info',
  ERROR = 'ERROR',
}

export type Banner = {
  type: BannerType;
  id: string;
  message: string;
};
